import { useNavigate } from 'react-router-dom';
import { useMfaRequirement } from '@/hooks/useMfaRequirement';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';

const MFA_SETUP_PATH = '/settings/security/mfa-setup';

export function MfaWarningBanner() {
  const navigate = useNavigate();
  const { requiresMfa, isInGracePeriod, gracePeriodDays } = useMfaRequirement();

  // Only show warning if MFA is required and user is in grace period
  if (!requiresMfa || !isInGracePeriod) {
    return null;
  }

  return (
    <Alert 
      variant="destructive" 
      className="mb-6" 
      role="alert" 
      aria-live="polite"
      data-testid="mfa-warning-banner"
    >
      <ShieldAlert className="h-4 w-4" />
      <AlertTitle>Multi-Factor Authentication Required</AlertTitle>
      <AlertDescription>
        Your admin role requires MFA. You have {gracePeriodDays} days remaining to enable MFA.
        <Button
          variant="outline"
          size="sm"
          className="ml-4"
          onClick={() => navigate(MFA_SETUP_PATH)}
          aria-label="Navigate to MFA setup"
        >
          Set Up MFA Now
        </Button>
      </AlertDescription>
    </Alert>
  );
}
